export default __webpack_public_path__ + "static/media/info-icon.436c15bf.svg";